<template>
  <v-layout row wrap align-space-around justify-center fill-height>
    <v-flex xs12 lg12 md12>
      <!-- dense align-top -->
      <v-timeline>
        <v-timeline-item
          v-for="(history, n) in this.histories"
          :key="n"
          :color="history.notify ? 'success' : 'error'"
          :icon="history.important ? 'warning' : history.notify ? 'email' : 'not_interested'"
          large
          small
        >
          <div slot="opposite">
            <p class="title font-weight-regular" v-html="history.name_"></p>
            <p class="caption grey--text text--darken-1" v-html="history.date"></p>
          </div>
          <v-card class="elevation-2">
            <v-card-title :class="history.notify ? 'success' : 'error'" dense>
              <h2 class="subheading white--text">{{ history.status.name }}</h2>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <span slot="activator">
                  <v-btn class="ma-0" flat small dark icon @click="changeImportant(history)">
                    <v-icon v-if="history.important">report_off</v-icon>
                    <v-icon v-else>report</v-icon>
                  </v-btn>
                </span>
                <span v-text="history.important ? 'Quitar destacado' : 'Destacar'"></span>
              </v-tooltip>
            </v-card-title>
            <v-card-text>
              <div v-html="history.message"></div>
              <v-btn
                v-if="history.photo != ''"
                flat
                :href="`https://storage.googleapis.com/rosalinda-imagenes/${history.photo}`"
                target="_blank"
                style="margin:0;"
              >
                Archivo
              </v-btn>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-flex>
    <v-fab-transition>
      <v-btn color="accent" dark fixed bottom right fab @click="this.openChangeStatus">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-layout>
</template>

<script>
import { GET_API, ORDER } from '../../config'

export default {
  name: 'HistoryOrder',
  props: ['order', 'openChangeStatus', 'getOrder'],
  data() {
    return {
      loading: false,
      histories: []
    }
  },
  watch: {
    order() {
      this.histories = this.order.histories
    }
  },
  mounted() {
    this.histories = this.order.histories
    this.$store.dispatch('updateTitle', `Historial - Pedido ${this.order.id}`)
  },
  methods: {
    async changeImportant(item) {
      await this.$http.put(`${ORDER}/${this.order.id}/history/${item.id}/important`, {
        important: item.important
      })
      this.getOrder()
    }
  }
}
</script>
